export default __webpack_public_path__ + "static/media/1.e5412f84.png";